import { useDispatch } from "react-redux";
import {
    updateBlogLike,
    updateBookmarkBlog,
} from "../../features/likeSaved/likeSavedSlice";

const BtnGroup = ({ blogId, likes, isSaved }) => {
    const dispatch = useDispatch();

    const handleLike = (id, blogLikes) => {
        dispatch(updateBlogLike({ id, blogLikes: blogLikes + 1 }));
    };

    const handleSaved = (id) => {
        dispatch(updateBookmarkBlog({ id, isSaved: !isSaved }));
    };

    return (
        <div className="btn-group">
            <button
                className="like-btn"
                id="lws-singleLinks"
                onClick={() => handleLike(blogId, likes)}
            >
                <i className="fa-regular fa-thumbs-up"></i> {likes}
            </button>

            <button
                className={`${isSaved && "active"} save-btn`}
                id="lws-singleSavedBtn"
                onClick={() => handleSaved(blogId, isSaved)}
            >
                <i className="fa-regular fa-bookmark"></i>{" "}
                {isSaved ? "Saved" : "Save"}
            </button>
        </div>
    );
};

export default BtnGroup;
